import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "klickl-pay-select" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "input" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_cell, {
      "is-link": "",
      icon: "aim",
      title: _ctx.getNameByCode(_ctx.modelValue, _ctx.list) || _ctx.$t('choose'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSheet = true))
    }, null, 8, ["title"]),
    _createVNode(_component_van_action_sheet, {
      show: _ctx.showSheet,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSheet = $event)),
      class: "cashier-field-select-sheet",
      teleport: ".checkout-counter .payment",
      description: _ctx.$t('choose'),
      "cancel-text": _ctx.$t('cancel'),
      "close-on-click-overlay": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_field, {
              label: ``,
              placeholder: _ctx.$t('search'),
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = $event)),
              "left-icon": "search",
              "right-icon": _ctx.search && 'clear',
              onClickRightIcon: _cache[2] || (_cache[2] = 
              () => {
                _ctx.search = '';
              }
            )
            }, null, 8, ["placeholder", "modelValue", "right-icon"])
          ])
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.key,
              onClick: ($event: any) => (_ctx.onSelectHandler(item))
            }, _toDisplayString(item.value), 9, _hoisted_4))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show", "description", "cancel-text"])
  ]))
}